import React from "react";
import Header from "./features/header/Header";
import Content from "./features/content/Content";

function App() {
  return (
    <>
      <Header />
      <Content />
    </>
  );
}

export default App;
